import * as React from "react";
import { SVGProps } from "react";
const TeamworkSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={27}
    height={26}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={27}
      height={26}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M.749 0h26v26h-26V0Z" />
    </mask>
    <g
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.8}
      mask="url(#a)"
    >
      <path d="m11.717 18.84-1.66-2.877a.338.338 0 0 1 .122-.461 1.261 1.261 0 0 1 1.724.46l.268.466v-4.4a.8.8 0 0 1 1.6 0v-.516c0-.433.336-.802.77-.818a.8.8 0 0 1 .828.8v.535a.8.8 0 0 1 1.6 0v1.068a.8.8 0 0 1 1.598 0v5.674c0 .74-.25 1.42-.671 1.961-.262.336-.4.752-.4 1.178l-.001 2.329c0 .1-.082.182-.182.182h-3.887a.182.182 0 0 1-.183-.182v-2.33c0-.423-.136-.838-.396-1.172a3.206 3.206 0 0 1-.213-.309M16.968 15.613v-2.516M15.37 15.613v-3.584M13.77 15.613v-3.584M16.945 6.373l-2.18 1.258M17.744 7.758 14.64 9.55M18.543 9.143l-3.103 1.791M8.955 11.013l2.178 1.258M9.754 9.629l2.892 1.67M10.554 8.244l3.103 1.792" />
      <path d="m22.932 8.325.267-.463c.095-.154.177-.315.244-.482.16-.393.45-.718.817-.93l2.017-1.164a.182.182 0 0 0 .067-.25L24.4 1.67a.182.182 0 0 0-.248-.066l-2.017 1.164c-.37.213-.799.3-1.22.242a3.184 3.184 0 0 0-2.035.399l-4.914 2.837a.8.8 0 0 0 .8 1.385l-.925.534a.8.8 0 1 0 .8 1.385l-.465.267a.8.8 0 0 0-.23 1.185M16.959 11.904l3.09-1.784-.268.465a1.261 1.261 0 0 0 .462 1.723.338.338 0 0 0 .46-.124l1.325-2.294M7.803 4.852h-.686a3.205 3.205 0 0 0-.54.03 1.904 1.904 0 0 1-1.213-.243L3.347 3.475a.182.182 0 0 0-.249.066L1.154 6.908a.182.182 0 0 0 .067.249L3.238 8.32c.369.213.659.541.82.936a3.185 3.185 0 0 0 1.362 1.562l4.914 2.837a.8.8 0 0 0 .8-1.385l.924.534c.037.021.075.04.113.054" />
      <path d="M13.738 8.236 10.646 6.45h.537c.697 0 1.261-.565 1.261-1.262a.338.338 0 0 0-.338-.337H9.58" />
    </g>
  </svg>
);
export default TeamworkSvg;
